export const mapFields = (createmode, removeElementBorder, updateValue, removeMargin, dontparseInput) => {
  const innerData =
    createmode === 'true' ? document.querySelector('.editor-wrapper') : document.querySelector('.preview-wrapper');

  //creating temp container
  const tempContainer = document.createElement('div');

  tempContainer.innerHTML = innerData.innerHTML;
  //to get styles for export and preview
  const editorContainer =
    createmode === 'true' ? tempContainer.querySelector('#editor') : tempContainer.querySelector('#preview-container');

  if (editorContainer) {
    const editorStyles = window.getComputedStyle(editorContainer);

    if (removeMargin) {
      tempContainer.style.marginTop = '0px';
      editorContainer.style.marginTop = '0px';
      tempContainer.style.marginBottom = '0px';
      editorContainer.style.marginBottom = '0px';
    }
    if (removeElementBorder) {
      tempContainer.style.border = '0px solid transparent';
      editorContainer.style.border = '0px solid transparent';
    } else {
      tempContainer.style.border = editorStyles.border;
      tempContainer.style.margin = editorStyles.margin;
    }
  }

  const mapinputEl = tempContainer;

  if (mapinputEl && !dontparseInput) {
    const dropdownEl = mapinputEl.querySelectorAll('.template-dropdown');
    // const inputEl = mapinputEl.querySelectorAll('.template-input');
    const dateEl = mapinputEl.querySelectorAll('.template-input-date');
    const ckBox = mapinputEl.querySelectorAll('.template-checkbox');

    ckBox.forEach(item => {
      if (item.getAttribute('checked') === 'false') {
        item.removeAttribute('checked');
      }
    });
    dropdownEl.forEach(item => {
      let parentEl = getParentElement(item);

      const newEl = document.createElement('span');
      newEl.setAttribute('id', item.getAttribute('id'));

      updateElement(newEl);

      parentEl.replaceWith(newEl);
    });

    dateEl.forEach(item => {
      let parentEl = getParentElement(item);
      const newEl = document.createElement('span');
      newEl.setAttribute('id', item.getAttribute('id'));

      updatevalue(item, newEl);

      updateElement(newEl);
      parentEl.replaceWith(newEl);
    });

    // inputEl.forEach(item => {
    //   let parentEl = getParentElement(item);
    //   const newEl = document.createElement('span');
    //   newEl.setAttribute('id', item.getAttribute('id'));

    //   updateElement(newEl);

    //   updatevalue(item, newEl);

    //   parentEl.replaceWith(newEl);
    // });
    return mapinputEl.innerHTML;
    // Get the CKEditor content
  }
  return mapinputEl.innerHTML;
};

function updateElement(newEl) {
  newEl.style.display = 'inline-block';
  newEl.style.width = 'auto';
  newEl.style.fontSize = '13px';
  newEl.style.fontWeight = 'bold';
}
function updatevalue(item, newEl) {
  if (item.getAttribute('value')) {
    newEl.innerHTML = item.getAttribute('value');

    // changing width of sign inputs
    const checkSigninput = newEl.getAttribute('id');

    if (checkSigninput) {
      const getStarting4letterfromId = checkSigninput?.slice(0, 4);
      const checkRecpId = checkSigninput?.slice(0, 9);
      if (getStarting4letterfromId === 'sign') {
        const currentWidth = item.getAttribute('value')?.length * 9;

        newEl.style.minWidth = currentWidth + 50 + 'px';
      }
      if (checkRecpId === 'recipient') {
        newEl.style.minWidth = 63 + 'px';
      }
    }
  } else if (item.getAttribute('type') === 'date') {
    newEl.innerHTML = 'dd/mm/yyyy';
  } else {
    newEl.innerHTML = item.getAttribute('name');
  }
}
function getParentElement(item) {
  let parentEl;
  const checkParentElement = item.parentElement.closest('.ck-widget');
  if (checkParentElement) {
    parentEl = checkParentElement;
    const checkgrandParent = checkParentElement.parentElement.closest('.ck-widget');
    if (checkgrandParent) {
      parentEl = checkgrandParent;
    }
  }
  return parentEl;
}
